import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_edfi-upload/artifacts/stz4w85h_IMG_8914.jpeg";
const SNPL_URL = "https://customer-assets.emergentagent.com/job_edfi-upload/artifacts/q6su2afr_IMG_9124.jpeg";

export const EdFiLogo = ({ size = 'md', linkTo = '/', className = '' }) => {
  const sizes = {
    xs: 'h-6',
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-14',
    xl: 'h-20',
  };

  const img = (
    <img
      src={LOGO_URL}
      alt="ed.fi"
      className={`${sizes[size]} w-auto object-contain ${className}`}
      style={{ mixBlendMode: 'multiply' }}
      data-testid="edfi-logo"
    />
  );

  if (linkTo) {
    return <Link to={linkTo} className="flex items-center">{img}</Link>;
  }
  return img;
};

export const SNPLLogo = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: 'h-10',
    md: 'h-16',
    lg: 'h-24',
    xl: 'h-32',
  };

  return (
    <img
      src={SNPL_URL}
      alt="Study Now. Pay Later."
      className={`${sizes[size]} w-auto object-contain ${className}`}
      data-testid="snpl-logo"
    />
  );
};

export { LOGO_URL, SNPL_URL };
